export enum PositionEnum {
    Superadministrador = 1,
    PoliciaMunicipal,
    Apozol,
    Apulco,
    Atolinga,
    BenitoJuarez,
    Calera,
    CanitasDeFelipePescador,
    Chalchihuites,
    ConcepcionDelOro,
    Cuauhtemoc,
    ElPlateadoDeJoaquinAmaro,
    ElSalvador,
    Fresnillo,
    GenaroCodina,
    GeneralEnriqueEstrada,
    GeneralFranciscoRMurguia,
    GeneralPanfiloNatera,
    Guadalupe,
    Huanusco,
    Jalpa,
    Jerez,
    JimenezDelTeul,
    JuanAldama,
    Juchipila,
    Loreto,
    LuisMoya,
    Mazapil,
    MelchorOcampo,
    MezquitalDelOro,
    MiguelAuza,
    Momax,
    MonteEscobedo,
    Morelos,
    MoyahuaDeEstrada,
    NochistlanDeMejia,
    NoriaDeAngeles,
    Ojocaliente,
    Panuco,
    Pinos,
    RioGrande,
    SainAlto,
    SantaMariaDeLaPaz,
    Sombrerete,
    Susticacan,
    Tabasco,
    Tepechitlan,
    Tepetongo,
    TeulDeGonzalezOrtega,
    TlaltenangoDeSanchezRoman,
    Trancoso,
    TrinidadGarciaDeLaCadena,
    Valparaiso,
    Vetagrande,
    VillaDeCos,
    VillaGarcia,
    VillaGonzalezOrtega,
    VillaHidalgo,
    Villanueva,
    Zacatecas,
    FiscaliaGeneralDeJusticiaDelEstado,
    PoliciaDeInvestigacion,
    MPs,
    Peritos,
    SSPSecretariaSeguridadPublicaDelEstado,
    PoliciaEstatal,
    Custodios,
    PoliciaVial,
    UsuarioEntidad,
    PoliciaMetropolitana,
    FuerzaDeReaccionInmediataZacatecas,
    GrupoOperativoRuralDeZacatecas,
    REPUVE
}
